export default __webpack_public_path__ + "static/media/warning-icon.04329cf9.svg";